import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PandadocService } from '@lmc-app/core/services/pandadoc.service';
import { Subject, takeUntil } from 'rxjs';

export interface PandadocPreviewData {
	id: string;
	name: string;
	status: string;
}

@Component({
	selector: 'app-pandadoc-preview-modal',
	templateUrl: './pandadoc-preview-modal.component.html',
	styleUrls: ['./pandadoc-preview-modal.component.scss'],
})
export class PandadocPreviewModalComponent implements OnInit, OnDestroy {
	pdfSource: Blob | null = null;
	isLoading = true;
	hasError = false;
	private destroy$ = new Subject<void>();

	constructor(
		private pandadocService: PandadocService,
		@Inject(MAT_DIALOG_DATA) public data: PandadocPreviewData
	) {}

	get displayStatus(): string {
		return (this.data?.status || '').replace('document.', '').replace(/_/g, ' ');
	}

	ngOnInit(): void {
		this.loadDocument();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	loadDocument(): void {
		this.isLoading = true;
		this.hasError = false;
		this.pandadocService
			.streamDocument(this.data.id)
			.pipe(takeUntil(this.destroy$))
			.subscribe({
				next: (blob: Blob) => {
					this.pdfSource = blob;
					this.isLoading = false;
				},
				error: (err) => {
					console.error('PandaDoc PDF load error:', err);
					this.hasError = true;
					this.isLoading = false;
				},
			});
	}

	openInPandadoc(): void {
		window.open(`https://app.pandadoc.com/a/#/documents/${this.data.id}`, '_blank');
	}
}
